import React, {useState} from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material'
import { deleteCreditHolidayRule } from 'utils/CreditHolidayRule'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack';

const DeleteCreditHolidayRule = ({open, setOpenDelete, selectedRow, reloading, rows}) => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)
    const data = rows.filter((row) => selectedRow.includes(row.id)).map((row) => ({ id: row.id, name: row.name }))

    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpenDelete(false)}
            >
                <DialogTitle>
                    <Typography variant='body3'>{ t('settings.credit_holiday_rule.dialog.titles.delete') }</Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography variant='body1'>
                        {t('settings.credit_holiday_rule.dialog.alerts.delete.message')}
                    </Typography>

                    <ul>
                        { data.map((credit_holiday_rule, index) =>
                            <li key={index}>
                                {credit_holiday_rule.name}
                            </li>
                        )}
                    </ul>
                </DialogContent>

                <DialogActions sx={{pb: 2, pr: 3}}>
                    <Button
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            deleteCreditHolidayRule(setLoading, selectedRow)
                            .then(() => {
                                setOpenDelete(false)
                                enqueueSnackbar(t('settings.credit_holiday_rule.dialog.alerts.delete.success'), { variant: 'success'})
                                reloading()
                            })
                            .catch((error) => {
                                console.error(error)
                                enqueueSnackbar(t('settings.credit_holiday_rule.dialog.alerts.delete.error'), { variant: 'error'})
                            })
                        }}
                        color='error'
                        loading={loading}
                    >
                        {t('general.buttons.delete')}
                    </Button>
                    <Button
                        variant='outlined'
                        onClick={() => setOpenDelete(false)}
                    >
                        {t('general.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export {DeleteCreditHolidayRule}
